const ERROR_MESSAGE_TYPE = 'CONTROLLED_MESSAGE'
const LOCAL_STORAGE_KEY = 'key'
const COMPETITIONS_OPEN = 'open'
const COMPETITIONS_LOST = 'lost'
const COMPETITIONS_GAVEN_UP = 'given'
const COMPETITIONS_WON = 'won'
const FAVORITE_LIST = 'favorites'
const LOCAL_STORAGE_QUERY_PARAMS = 'query_params'

export const COMPETITORS_QUANTITY = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3
}

export const IN_COMPETITIONS_STATUS = {
    IN_COMPETITIONS: 'IN_COMPETITIONS',
    NOT_IN_COMPETITIONS: 'NOT_IN_COMPETITIONS',
    ON_COMPETITIONS: 'ON_COMPETITIONS',
    OFF_COMPETITIONS: 'OFF_COMPETITIONS'
}

export const PLAN_CODES = {
    FREE_PLAN_CODE: 1,
    MONTH_PLAN_CODE: 2,
    SEMESTER_PLAN_CODE: 3,
    YEARLY_PLAN_CODE: 4
}

const FLOW_USER_TYPES = {
    MEASURER: 'MEASURER',
    INSTALLER: 'INSTALLER',
    CLIENT: 'CLIENT',
}

export {
    ERROR_MESSAGE_TYPE,
    LOCAL_STORAGE_KEY,
    COMPETITIONS_OPEN,
    COMPETITIONS_LOST,
    COMPETITIONS_GAVEN_UP,
    COMPETITIONS_WON,
    FAVORITE_LIST,
    LOCAL_STORAGE_QUERY_PARAMS,
    FLOW_USER_TYPES,
}